import { makeStyles } from '@material-ui/styles';
import { white, silver } from '../../../constants/Colors';
import { inputColors } from '../../material-ui-kit/material-kit-pro-react';

export default makeStyles(() => {
    const commonEditorStyles = {
        padding: '0',
        margin: '0',
        backgroundColor: white,
        borderRadius: '3px',
        '& > div': {
            border: 'none',
            borderRadius: '3px',
        },
    };

    return ({
        root: {},
        subjectTextEditor: {
            ...commonEditorStyles,
            border: ({ emailSubjectError }) => {
                if (emailSubjectError) {
                    return `1px solid ${inputColors.error.borderColor}`;
                }

                return `1px solid ${silver}`;
            },
            borderBottomLeftRadius: '0',
            borderBottomRightRadius: '0',
        },
        bodyTextEditor: {
            ...commonEditorStyles,
            marginTop: ({ emailSubjectError, emailBodyError }) => {
                if (emailSubjectError && emailBodyError) {
                    return '-1px';
                }

                if (!emailSubjectError) {
                    return '-1px';
                }

                return '0';
            },
            height: ({ showSubject }) => (showSubject ? 'calc(100% - 75px)' : 'calc(100% - 10px)'),
            border: ({ emailBodyError }) => {
                if (emailBodyError) {
                    return `1px solid ${inputColors.error.borderColor}`;
                }

                return `1px solid ${silver}`;
            },
            borderTop: ({ emailSubjectError, emailBodyError }) => {
                if (emailBodyError) {
                    return `1px solid ${inputColors.error.borderColor}`;
                }

                if (emailSubjectError) {
                    return 'none';
                }

                return `1px solid ${silver}`;
            },
            borderTopLeftRadius: '0',
            borderTopRightRadius: '0',
        },
    });
});
